import { Controller } from "@hotwired/stimulus"

// Toggles the pricing display between monthly and yearly, and keeps the
// checkout forms' hidden "period" field in sync.
export default class extends Controller {
  static targets = ["period", "monthlyBtn", "yearlyBtn"]
  static values = { period: { type: String, default: "monthly" } }

  connect() { this.render() }
  select(event) { this.periodValue = event.params.period }
  periodValueChanged() { this.render() }

  render() {
    this.element.dataset.period = this.periodValue
    this.periodTargets.forEach((input) => { input.value = this.periodValue })
    const monthly = this.periodValue === "monthly"
    this.monthlyBtnTarget.classList.toggle("bg-white", monthly)
    this.monthlyBtnTarget.classList.toggle("shadow-sm", monthly)
    this.monthlyBtnTarget.classList.toggle("text-gray-900", monthly)
    this.yearlyBtnTarget.classList.toggle("bg-white", !monthly)
    this.yearlyBtnTarget.classList.toggle("shadow-sm", !monthly)
    this.yearlyBtnTarget.classList.toggle("text-gray-900", !monthly)
  }
}
